<template>
  <div class="reminders">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="newReminder()" class="btn fixed_btn">New Reminder</button>
      <div class="card">
        <p class="title">Your Reminders</p>
        <div class="table-holder">
          <table>
            <thead>
              <tr>
                <th>Form</th>
                <th>Time</th>
                <th>Locations</th>
                <th>Departments</th>
                <!-- <th>Exceptions</th> -->
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-if="reminders.length">
                <template v-for="(item, i) in reminders">
                  <tr :key="i" :class="{ grey: i % 2 }">
                    <td data-label="Form">{{ formsMap[item.form_id] }}</td>
                    <td data-label="Time">
                      {{ item.time | format_schedule_time }}
                    </td>
                    <td
                      data-label="locations"
                      v-html="
                        all_selected(listToString(item.locations, 'locationsMap'))
                      "
                    ></td>
                    <td
                      data-label="Departments"
                      v-html="
                        all_selected(
                          listToString(item.departments, 'departmentsMap')
                        )
                      "
                    ></td>
                    <!-- <td data-label="Exceptions" hidden>
                      <span
                        class="exceptions"
                        v-for="(exception,type) in item.exceptions"
                        :key="type"
                      >{{exception.length}} {{type}}</span>
                    </td> -->
                    <td data-label="Status">
                      {{ item.status ? "Active" : "Paused" }}
                    </td>
                    <td data-label="Edit">
                      <img
                        @click="handleEdit(item)"
                        class="action clickable"
                        src="@/assets/img/edit.svg"
                      />
                    </td>
                  </tr>
                  <tr :class="{ grey: i % 2 }">
                    <td colspan="100" class="full">
                      <div class="btns right">
                        <button
                          class="btn round-btn"
                          @click="changeReminderState(item)"
                        >
                          {{ item.status ? "Pause" : "Resume" }}
                        </button>
                        <button
                          class="btn round-btn"
                          @click="runReminder(item)"
                        >
                          Run Now
                        </button>
                      </div>
                    </td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr>
                  <td>You have no reminders set</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="pagination">
          <div
            class="action prev"
            :class="{ inactive: !pagination.previous_doc }"
            @click="moveToPage(0)"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action prev"
            :class="{ inactive: !pagination.previous_doc }"
            @click="moveToPage(0)"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <!-- <div class="pages">
            <div class='action page active' >
              {{((pagination.current_page-1)*pagination.page_size)+1}}-{{pagination.current_page*pagination.page_size}} of {{usage[source+'s']}}
            </div>
          </div>-->
          <div
            class="action next"
            :class="{ inactive: !pagination.next_doc }"
            @click="moveToPage(1)"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action next"
            :class="{ inactive: !pagination.next_doc }"
            @click="moveToPage()"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Register from "@/components/Register";
import DashboardPages from "@/utilities/menu.js";
import Moment from "moment-timezone";
import Swal from "sweetalert2";
import { mapState } from "vuex";
import { db, auth, functions } from "../firebaseConfig.js";

export default {
  name: "Reminders",
  components: {
    register: Register,
  },
  data() {
    return {
      details: null,
      reminders: [],
      forms: [],
      source: "managers",
      pagination: {
        previous_doc: null,
        next_doc: null,
        page_size: 10,
        current_page: 1,
      },
      managers: [],
      departments: [],
      locations: [],
    };
  },
  firestore() {
    return {
      reminders: db.collection(`user/${this.user_doc.id}/reminders`),
      forms: db.collection(`user/${this.user_doc.id}/forms`),
      departments: db.collection(`user/${this.user_doc.id}/departments`),
      locations: db.collection(`user/${this.user_doc.id}/locations`),
    };
  },
  computed: {
    
    formsMap() {
      let forms = {};
      this.forms.forEach((d) => {
        forms[d.id] = d.title;
      });
      return forms;
    },
    departmentsMap() {
      let departments = {};
      this.departments.forEach((d) => {
        departments[d.id] = d.name;
      });
      return departments;
    },
    locationsMap() {
      let locations = {};
      this.locations.forEach((d) => {
        locations[d.id] = d.name;
      });
      console.log(locations)
      return locations;
    },
  },

  filters: {
    format_schedule_time(times) {
      let raw_string =
        times.days.map((d) => Moment(`${d}`, "d").format("dddd")).join(", ") +
        " | " +
        Moment(`${times.hour}:${times.minute}`, "H:m").format("hh:mm a");
      return raw_string;
    },
  },
  methods: {
    changeReminderState(reminder) {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      const jobToRun = reminder.status
        ? "reminders-pauseJob"
        : "reminders-resumeJob";
      const changeJobState = functions.httpsCallable(jobToRun);
      return changeJobState({
        user_id: this.user_doc.id,
        reminder_id: reminder.id,
      })
        .then(() => {
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
          return Swal.fire(
            "Error: ",
            `${err.message} Please try again later`,
            "error"
          );
        });
    },
    runReminder(reminder) {
      const runJob = functions.httpsCallable("reminders-runJob");
      return Swal.fire({
        title: `Send "${this.formsMap[reminder.form_id]}" `,
        text: "Are you sure you want to send this form out now?",
        showCancelButton: true,
        confirmButtonText: "Send",
        type: "question",
      })
        .then((result) => {
          if (result.value) {
            let loader = this.$loading.show({
              container: null,
              canCancel: false,
            });
            return runJob({
              user_id: this.user_doc.id,
              reminder_id: reminder.id,
            })
              .then((result) => {
                loader.hide();
                return Swal.fire(
                  "Success",
                  "Sending has completed!",
                  "success"
                );
              })
              .catch((err) => {
                loader.hide();
                return Swal.fire(
                  "Error: ",
                  `${err.message} Please try again later`,
                  "error"
                );
              });
          }
        })
        .catch((err) => {
          console.error(err);
          return Swal.fire(
            "Error: ",
            `${err.message} Please try again later`,
            "error"
          );
        });
    },
    all_selected(input_str) {
      if (!input_str) {
        return "ALL";
      } else {
        return input_str;
      }
    },
    listToString(arr, field) {
      return arr
        .reduce((acc, curr) => {
          if (this[field][curr]) {
            return `${acc}<br/>${this[field][curr]}`;
          } else {
            return acc;
          }
        }, "")
        .substring(5);
    },
    moveToPage(page) {
      let pagination = this.pagination;
      let ref = db
        .collection("user")
        .doc(this.user_doc.id)
        .collection(this.source);
      if (this.filter_values) {
        for (const key in this.filter_values) {
          if (this.filter_values.hasOwnProperty(key) && this.filter_values) {
            const element = this.filter_values[key];
            if (element) {
              ref = ref.where(`${key}.id`, "==", element.id);
            }
          }
        }
      }
      if (page === -1) {
        //Previous Page
        ref = ref
          .limit(pagination.page_size)
          .orderBy("name", "desc")
          .startAfter(pagination.previous_doc);
      } else if (page === 1) {
        //Next Page
        ref = ref
          .limit(pagination.page_size)
          .orderBy("name")
          .startAfter(pagination.next_doc);
      } else if (page === 0) {
        //First page
        ref = ref.limit(pagination.page_size).orderBy("name");
      } else {
        //Last page
        let total = this.usage[this.source + "s"];
        let last_full_page = Math.floor(total / pagination.page_size);
        let limit = total - last_full_page * pagination.page_size;
        ref = ref.limit(limit || pagination.page_size).orderBy("name", "desc");
      }

      ref.get().then((query) => {
        let docs = query.docs;

        if (page === -1 || page === undefined) {
          // counting down
          docs.reverse();
        }
        if (query.size === 0 && page !== 0) {
          if (page === 1) {
            this.pagination.next_doc = null;
          } else if (page === -1) {
            this.pagination.previous_doc = null;
          }
        } else {
          let managers = docs.map((d) => Object.assign({ id: d.id }, d.data()));
          this.pagination.previous_doc = docs[0];
          this.pagination.next_doc = docs[docs.length - 1];
          if (page === 0) {
            this.pagination.previous_doc = null;
            this.pagination.current_page = 1;
            if (query.size < pagination.page_size) {
              this.pagination.next_doc = null;
            }
          } else if (page === undefined) {
            let total = this.usage[this.source];
            let last_full_page = Math.ceil(total / pagination.page_size);
            this.pagination.next_doc = null;
            this.pagination.current_page = last_full_page;
          } else {
            this.pagination.current_page += page;
            if (query.size < pagination.page_size) {
              this.pagination[page === -1 ? "previous_doc" : "next_doc"] = null;
            }
          }
          this.managers = managers;
        }
        this.pagination = Object.assign({}, this.pagination);
      });
      return true;
    },
    handleEdit(item) {
      this.$router.push("reminderManagement/" + item.id);
    },
    newReminder() {
      let id = db.collection(`user/${this.user_doc}/reminders`).doc().id;
      this.goTo("/reminderManagement/" + id);
    },
  },
};
</script>

<style lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
}

tr .title {
  font-size: 14px !important;
  margin-bottom: 8px;
  color: #ff9800;
}

span.exceptions {
  display: block;
  width: 100%;
}

.grey {
  li {
    background: rgb(255 165 34 / 13%);
  }
}

.full .btn {
  margin-right: 15px;
  margin-bottom: 10px;
}
</style>
